module.exports = __webpack_public_path__ + "img/voice_input.75b4d175.png";